<template>
  <section class="exchangePanel">
    <div>
      <header>
        <div>
          <p>
            <b>
              {{ disponiveis.length }} itens disponíveis
            </b>
          </p>
          <a href="#" class="btn btn-secondary btn-small" @click.prevent="addAll()">
            Selecionar Tudo
          </a>
        </div>
        <div class="search-box">
          <fa :icon="['far','magnifying-glass']" class="ic"/>
          <input type="text" placeholder="O que você procura?" v-model="filtroDisponiveis" />
        </div>
      </header>
      <div>
        <ul>
          <li
            v-for="( item ) in disponiveisFiltrados"
            :key="item.idMotivoBLoqueio"
            @click.prevent="addToSelected(disponiveis.indexOf(item))"
          >
            <span>{{ item.descricao }}</span>
            <fa :icon="['fal','arrow-right-long']" class="ic"/>
          </li>
        </ul>
      </div>
    </div>
    <div>
      <header>
        <div>
          <p>
            <b>
              {{ selecionados.length }} itens selecionados
            </b>
          </p>
          <a href="#" class="btn btn-secondary btn-small" @click.prevent="removeAll()">
            Remover Tudo
          </a>
        </div>
        <div class="search-box">
          <fa :icon="['far','magnifying-glass']" class="ic"/>
          <input type="text" placeholder="O que você procura?" v-model="filtroSelecionados" />
        </div>
      </header>
      <div>
        <ul>
          <li
              v-for="( item ) in selecionadosFiltrados"
              :key="item.idMotivoBLoqueio"
              @click.prevent="removeFromSelected(selecionados.indexOf(item))"
            >
            <span>{{ item.descricao }}</span>
            <fa :icon="['fal','arrow-left-long']" class="ic"/>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import NegociaService from '@/services/negocieja.service.js'

export default {
  props: {
    bloqueios: {
      type: Array
    }
  },
  data () {
    return {
      disponiveis: [],
      selecionados: [],
      filtroDisponiveis: '',
      filtroSelecionados: ''
    }
  },
  watch: {
    bloqueios ( value ) {
      if ( value ) {
        this.getBloqueios()
      }
    }
  },
  mounted () {
    this.getBloqueios()
  },
  computed: {
  disponiveisFiltrados () {
    if (!this.filtroDisponiveis.trim()) return this.disponiveis
    return this.disponiveis.filter(item =>
      item.descricao.toLowerCase().includes(this.filtroDisponiveis.toLowerCase())
    )
  },
  selecionadosFiltrados () {
    if (!this.filtroSelecionados.trim()) return this.selecionados
    return this.selecionados.filter(item =>
      item.descricao.toLowerCase().includes(this.filtroSelecionados.toLowerCase())
    )
  }
  },
  methods: {
    getBloqueios () {
      NegociaService.getBloqueios().then( 
        response => {
          const bloqueios = Object.assign([], response.data)

          this.selecionados = bloqueios.filter( a => this.bloqueios.includes(a.idmotivoBloqueio))
          this.disponiveis = bloqueios.filter( a => !this.bloqueios.includes(a.idmotivoBloqueio))

          this.emitList()
        },
        error => {
          console.error('Erro ao buscar formas de pagamento:', error)
        }
      )
    },
    addToSelected ( i, scape ) {
      const item = this.disponiveis[i]

      this.selecionados.push(item)

      if ( !scape ) {
        this.disponiveis.splice(i,1)
      }

      this.emitList()
            
    },
    removeFromSelected ( i, scape ) {
      const item = this.selecionados[i]
      const originalIndex = item.originalIndex

      if ( originalIndex || originalIndex == 0 ) {
        delete item.originalIndex

        this.disponiveis.splice(originalIndex, 0, item)
      } else {
         this.disponiveis.push(item)
      }
      
      if ( !scape ) {
        this.selecionados.splice(i,1)
      }

      this.emitList()
    },
    addAll () {
      this.disponiveis.map( (k,i) => {
        // console.log("addAll:", k)
        this.addToSelected(i, true)
      })

      this.$nextTick(() => {
        this.disponiveis = []
        this.emitList()
      })

      
    },
    removeAll () {
      this.selecionados.map( (k,i) => {
        this.removeFromSelected(i, true)
      })

      this.$nextTick(() => {
        this.selecionados = []
        this.emitList()
      })

      
    },
    emitList () {
      this.$emit("onChange", this.selecionados)
    }
  }
}
</script>

<style lang="scss" scoped>
  .exchangePanel {
    > div {
      height: 100%;
      display: flex; flex-direction: column;

      header {
        width: 100%;

        >div {
          position: relative;

          p {
            padding: 0; margin: 0;
          }

          &:first-child {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: $mg_mini $hmg_small;
          }

          &.search-box {
            background-color: $color-bg;
            border-top: $border-component;
            border-bottom: $border-component;
            height: 40px;

            input {
              background: transparent;
              padding: 0 $hmg_small;
              width: 100%; height: 100%;
              border: 0; box-shadow: none;
              font-size: $font-size-small;

              &::placeholder {
                color: $color-mid-grey;
              }
              &:focus {
                outline: none;
                box-shadow: none;
                border: 0;
              }
            }
            .ic {
              position: absolute;
              right: $hmg_small;
              top: 50%; transform: translateY(-50%);
            }
          }
        }
      }

      > div {
        flex: 1;
        overflow: auto;
        @extend %scrollbar_light_panel;

        ul {
          padding: 0; margin: 0;

          li {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: $mg_mini $hmg_small;
            list-style: none;
            border-bottom: $border-component;
            cursor: default;

            .ic {
              @extend %transition_3e;
            }

            &:hover {
              .ic {
                color: $color-primary;
              }
            }
          }
        }
      }
    }
    
  }
</style>